<style>
.msg-block {
  text-align: center;
}

.notification-del-block .cancel {
  height: 50px;
  width: 50px;
  top: 130px;
  left: 0;
}

.notification-del-block .cancel.notification-without-phone {
  height: 50px;
  width: 50px;
  top: 80px;
  left: 0;
}
</style>

<template>
  <div
    class="offset-1 col-10 row"
    :class="{success_end_line: success_status, warning_end_line: warning_status}"
  >
    <div class="offset-md-3 col-md-6 msg-block">
      <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
    </div>
    <div class="col-11 row notification-contact-form">
      <div class="col-12 row input-setting-block">
        <div class="col-4 item-name">Имя и фамилия</div>
        <div class="col-8">
          <input :class="{fail: msg_name}" type="text" v-model="self_name">
        </div>
      </div>
      <div v-if="msg_name" class="offset-4 col-8 after-input-msg">
        <p>{{msg_name}}</p>
      </div>
      <div class="col-12 row input-setting-block">
        <div class="col-2">
          <input
            :id="idCheckboxMail"
            type="checkbox"
            autocomplete="off"
            v-model="self_mail_status"
            @change="changeMailStatus"
          >
          <label :for="idCheckboxMail">.</label>
        </div>
        <div class="col-2 item-name">Почта</div>
        <div class="col-8">
          <input type="mail" :class="{fail: msg_mail}" v-model="self_mail">
        </div>
        <div v-if="msg_mail" class="offset-4 col-8 after-input-msg">
          <p>{{msg_mail}}</p>
        </div>
      </div>
      <div class="col-12 row input-setting-block" v-if="biling">
        <div class="col-2">
          <input
            :id="idCheckboxPhone"
            type="checkbox"
            autocomplete="off"
            v-model="self_tel_status"
            @change="changeTelStatus"
          >
          <label :for="idCheckboxPhone">.</label>
        </div>
        <div class="col-2 item-name">Телефон</div>
        <div class="col-8">
          <input
            type="phone"
            :class="{fail: msg_phone}"
            v-mask="'+# (###) ###-##-##'"
            v-model="self_tel_in_mask"
          >
        </div>
        <div v-if="msg_phone" class="offset-4 col-8 after-input-msg">
          <p>{{msg_phone}}</p>
        </div>
      </div>
    </div>
    <div class="col-1">
      <div class="notification-del-block">
        <b-btn class="icon cancel" :id="nameDelButtton" @click="del_popover = !del_popover" :class="{'notification-without-phone': !biling}"></b-btn>
      </div>
      <b-popover
        :show.sync="del_popover"
        :target="nameDelButtton"
        title="Удалить этот контакт"
        class="notification-del-popover"
      >
        <button type="button" class="btn btn-outline-danger" @click="deleteNotificationUtilizer">Да</button>
        <button type="button" @click="onCloseDelPopover" class="btn btn-outline-info">Нет</button>
      </b-popover>
    </div>
    <div class="col-12 end-line-block"></div>
  </div>
</template>

<script>
import msg from "./msg.vue";
import axios from "axios";
import config from "@/config.js";
import loader from "./loader.vue";
import { VueMaskDirective } from "v-mask";
import { store } from "@/store";

export default {
  created() {},
  components: {
    "loader-component": loader,
    "msg-component": msg
  },
  directives: {
    mask: VueMaskDirective
  },
  props: [
    "id_utilizer",
    "name",
    "mail_status",
    "tel",
    "tel_status",
    "mail",
    "index"
  ],
  data: function() {
    return {
      msg_general: {
        type: "hidden",
        text: ""
      },
      loader: true,
      self_id_utilizer: this.id_utilizer,
      self_name: this.name,
      self_mail: this.mail,
      self_mail_status: this.mail_status,
      self_tel: this.tel,
      self_tel_in_mask: this.tel,
      self_tel_status: this.tel_status,
      msg_mail: "",
      msg_name: "",
      msg_phone: "",
      del_popover: false,
      success_status: false,
      warning_status: false,
      biling: false
    };
  },
  computed: {
    idCheckboxPhone: function() {
      return "phone-" + this.index;
    },
    idCheckboxMail: function() {
      return "mail-" + this.index;
    },
    nameDelButtton: function() {
      return "del-notification-" + this.index;
    }
  },
  methods: {
    changeMailStatus: function() {
      saveUtilizer(this);
    },
    changeTelStatus: function() {
      saveUtilizer(this);
    },
    onCloseDelPopover() {
      this.del_popover = false;
    },
    deleteNotificationUtilizer: function() {
      deleteNotificationUtilizer(this);
    }
  },
  watch: {
    self_name: function(this_name, old_name) {
      this.success_status = this.warning_status = false;
      if (
        (typeof old_name != "undefined" || old_name != null) &&
        this_name != old_name
      ) {
        setTimeout(() => {
          if (this_name == this.self_name) {
            saveUtilizer(this);
          }
        }, 3000);
      }
    },
    self_mail: function(this_mail, old_mail) {
      this.success_status = this.warning_status = false;
      if (
        (typeof old_mail != "undefined" || old_mail != null) &&
        this_mail != old_mail
      ) {
        this.msg_mail = "";
        setTimeout(() => {
          if (this_mail == this.self_mail) {
            saveUtilizer(this);
          }
        }, 3000);
      }
    },
    self_tel: function(this_phone, old_phone) {
      this.success_status = this.warning_status = false;
      console.log(this_phone, old_phone);
      if (
        (typeof old_phone != "undefined" || old_phone != null) &&
        this_phone != old_phone
      ) {
        setTimeout(() => {
          if (this_phone == this.self_tel) {
            saveUtilizer(this);
          }
        }, 3000);
      }
    },
    self_tel_in_mask: function(this_phone, old_phone) {
      var convert_phone = this_phone.replace(/[^0-9]/gi, "");
      // var convert_old_phone = old_phone.replace(/[^1-9]/gi,"")
      console.log(convert_phone);
      if (
        (typeof old_phone != "undefined" || old_phone != null) &&
        this.self_tel.toString != convert_phone
      ) {
        this.self_tel = convert_phone;
      }
    }
  }
};

function saveUtilizer(vue_obj) {
  vue_obj.msg_general = {
    type: "hidden",
    text: ""
  };
  vue_obj.msg_name = "";
  vue_obj.msg_mail = "";
  vue_obj.msg_phone = "";

  var post_data = new FormData();
  post_data.set("token", localStorage.token);
  post_data.set("id_utilizer", vue_obj.self_id_utilizer);
  post_data.set("id_group", vue_obj.$route.params.id_group);
  post_data.set("name", vue_obj.self_name);
  post_data.set("mail", vue_obj.self_mail);
  post_data.set("mail_status", vue_obj.self_mail_status);
  post_data.set("tel", vue_obj.self_tel);
  post_data.set("tel_status", vue_obj.self_tel_status);

  axios({
    method: "POST",
    url: config.API_HOST + "/notifications/set_notification",
    data: post_data
  })
    .then(function(request) {
      console.log(request);
      if (!!request.data.id_utilizer) {
        vue_obj.self_id_utilizer = request.data.id_utilizer;
        vue_obj.success_status = true;
        setTimeout(() => {
          vue_obj.success_status = false;
        }, 5000);
      }
    })
    .catch(function(error) {
      if (!!error.response.data.exception) {
        vue_obj.msg_general = {
          type: "alert",
          text: error.response.data.exception
        };
      }

      vue_obj.warning_status = true;

      error.response.data.fields_exceptions.forEach(element => {
        if (element["name"] == "mail" || element["name"] == "mail_status") {
          vue_obj.msg_mail = element["exception"];
        } else if (
          element["name"] == "tel" ||
          element["name"] == "tel_status"
        ) {
          vue_obj.msg_phone = element["exception"];
        } else if (element["name"] == "name") {
          vue_obj.msg_name = element["exception"];
        }
      });
    });
}

function deleteNotificationUtilizer(vue_obj) {
  if (!!localStorage.token) {
    if (vue_obj.self_id_utilizer == null) {
      vue_obj.$emit("deleteRow");
    } else {
      var post_data = new FormData();
      post_data.set("token", localStorage.token);
      post_data.set("id_utilizer", vue_obj.self_id_utilizer);
      axios({
        method: "POST",
        url: config.API_HOST + "/notifications/delete",
        data: post_data
      })
        .then(function(response) {
          vue_obj.$emit("deleteRow");
        })
        .catch(function(error) {
          console.log(error);
        });
    }
    vue_obj.del_popover = false;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/notification-utilizer.vue